export default () =>{
    const equalize = document.querySelectorAll('.equalize-block')
 
    if(!equalize) return;
   console.log(equalize)
    equalize.forEach(blocks=>{
        let maxHeight = 0
      
        blocks.querySelectorAll('.eq-block').forEach(block=>{
            console.log(block.offsetHeight)
            if (block.height > maxHeight) { maxHeight = block.height; }
          
        console.log(maxHeight)
        })
        // blocks.querySelectorAll('.eq-block > block').forEach(block=>{
           
        //     block.style.height = cur
          
        
        // })
    })
    return;
}

